import { FoodTypesDto } from "@gtpl/shared-models/masters";
import { Uoms } from "../../uoms/uom.entity";
import { PackingMethod } from "../packing-methods.entity";
import {  PackingMethodsDTO } from "./packing-methods.dto";

export class PackingMethodAdapter {
    convertDtoToEntity(dtoObj: PackingMethodsDTO,  isUpdate: boolean = false ): PackingMethod {
        try {
            console.log(dtoObj);
            const entityObj = new PackingMethod();
            entityObj.createdUser = dtoObj.createdUser;
            entityObj.packingMethodName = dtoObj.packingMethodName;
            entityObj.noOfPouches = dtoObj.noOfPouches;
            entityObj.pouchesPerRow = dtoObj.pouchesPerRow;
            entityObj.palletCapacity = dtoObj.palletCapacity;
            entityObj.maxPalletCapacity = Number(dtoObj.palletCapacity) + Number(Number(dtoObj.palletCapacity) * 10)/100;

            // entityObj.uomInfo = new Uoms();
            entityObj.uomId = dtoObj.uomId;

            if (dtoObj.packingMethodId) {
                entityObj.packingMethodId = dtoObj.packingMethodId;
                entityObj.updatedUser = dtoObj.updatedUser;
            }
            entityObj.isActive = dtoObj.isActive;
            return entityObj;
        } catch (Error) {
            return Error;
        }
    }

    public convertEntityToDto(employeeObject: PackingMethod): PackingMethodsDTO {
        const foodTypeDetailsDTO= new PackingMethodsDTO;
        foodTypeDetailsDTO.packingMethodId = employeeObject.packingMethodId;
        foodTypeDetailsDTO.packingMethodName = employeeObject.packingMethodName;
        foodTypeDetailsDTO.noOfPouches = employeeObject.noOfPouches;
        foodTypeDetailsDTO.pouchesPerRow = employeeObject.pouchesPerRow;
        foodTypeDetailsDTO.uomId = employeeObject?.uomInfo?.uomId;
        foodTypeDetailsDTO.isActive = employeeObject.isActive;
        foodTypeDetailsDTO.createdAt = employeeObject.createdAt;
        foodTypeDetailsDTO.updatedAt = employeeObject.updatedAt;
        foodTypeDetailsDTO.createdUser = employeeObject.createdUser;
        foodTypeDetailsDTO.updatedUser = employeeObject.updatedUser;
        foodTypeDetailsDTO.versionFlag = employeeObject.versionFlag;
        foodTypeDetailsDTO.palletCapacity=employeeObject.palletCapacity;
        foodTypeDetailsDTO.maxPalletCapacity=employeeObject.maxPalletCapacity;

        return foodTypeDetailsDTO;
      }
}